import React from 'react';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import OrdenesCargaCombustibleView from '../OrdenesCargaCombustibleView';
import OrdenesCargaCombustibleMovilView from './OrdenesCargaCombustibleMovilView';

/**
 * Vista automática que detecta el dispositivo y muestra la versión apropiada
 * del hub de Órdenes de Carga de Combustible.
 */
const OrdenesCargaCombustibleAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();
  const esMobileOTablet = isMobile || isTablet;

  if (esMobileOTablet) {
    return <OrdenesCargaCombustibleMovilView />;
  }

  return <OrdenesCargaCombustibleView />;
};

export default OrdenesCargaCombustibleAutoView;
